module.exports = __webpack_public_path__ + "img/ground.e656d7ee.png";